import { define, Model, AttributesMixin, type } from "@type-r/models";
import { restfulIO } from 'api/endpoint';

export interface CashLotItem extends AttributesMixin<typeof CashLotItem> { }
export interface CashLotComputedValues extends AttributesMixin<typeof CashLotComputedValues> { }

@define
export class CashLotItem extends Model {

  static attributes = {
    currency: String,
    region: String,
    legalEntityName: String,
    period: Date,
    amount: Number,
    type: String,
    subType: String,
    variance: Number,
    state: String,
    source: String,
    count: Number,
    accountRefId: String
  };
}

@define
export class CashLotComputedValues extends Model {

  static attributes = {
    reconciledArInvoicesTotal :Number,
    unreconciledArInvoicesTotal : Number,
    bookedArPaymentsTotal: Number,
    unreconciledArPaymentsTotal: Number,
    averageDso: Number,
    averageDaysDeliquent: Number
  };
}

export interface CashLot extends AttributesMixin<typeof CashLot> { }

@define
export class CashLot extends Model {
  static endpoint = restfulIO('/api/v1/incash/cash-balance/search');

  static attributes = {
    items: type([CashLotItem]).dontSave,
    computedValues: type(CashLotComputedValues).dontSave,
    startDate: Date,
    endDate: Date,
    effectiveDate: Date,
    currencies: type([String]),
    conversationIds: type([Number]),
    regions: type([String]),
    accounts: type([String]),
    frequency: String
  }
}
